import { render, staticRenderFns } from "./chinaIndex.vue?vue&type=template&id=2324350c&scoped=true&"
import script from "./chinaIndex.vue?vue&type=script&lang=js&"
export * from "./chinaIndex.vue?vue&type=script&lang=js&"
import style0 from "./chinaIndex.vue?vue&type=style&index=0&id=2324350c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2324350c",
  null
  
)

export default component.exports